import React, { FC, MouseEventHandler } from 'react'
import { useTranslations } from 'next-intl'
import { GENERATE_PASSWORD_BUTTON } from './constants'
import { StarIcon } from './components/StarIcon'
import { Button2 } from '../../../Button2/Button2'
import style from './GenerateButtonPassword.module.css'

type GeneratePasswordButtonProps = {
  onMouseDown: MouseEventHandler
}

export const GeneratePasswordButton: FC<GeneratePasswordButtonProps> = ({ onMouseDown }) => {
  const t = useTranslations()
  const generatePasswordButton = t(GENERATE_PASSWORD_BUTTON)

  return (
    <Button2
      data-testid="generate-password-button"
      className={style.generatePasswordButton}
      onMouseDown={onMouseDown}
      outline
    >
      <StarIcon className={style.star} />
      {generatePasswordButton}
    </Button2>
  )
}
